var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{ref:_vm.playerId,class:[_vm.videoClass],attrs:{"id":_vm.playerId,"playsinline":"","width":"","height":""}},[_vm._l((_vm.subtitles),function(track,key){return [(track)?_c('track',{key:key,attrs:{"label":_vm.availableSubtitlesLanguage[key],"kind":"subtitles","srclang":key,"src":track.url}}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }